import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoCadastro } from './../models/projeto-cadastro.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AgregadorService extends BaseService<ProjetoCadastro> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/agregador';
  }
  public getById(id: number, filterProds: any = null): Observable<ProjetoCadastro> {
    return this.http.get<ProjetoCadastro>(this.baseUrl + '/' + id + '?filterProds=' + filterProds, { headers: this.headers });
  }
}
